(function () {
  'use strict';

  var section = document.querySelector('[data-influencer-section]');
  if (!section) return;

  var track = section.querySelector('[data-influencer-track]');
  var modal = document.querySelector('[data-influencer-modal]');
  if (!track || !modal) return;

  // Modal elements
  var mImg = modal.querySelector('[data-influencer-modal-img]');
  var mHandle = modal.querySelector('[data-influencer-modal-handle]');
  var mName = modal.querySelector('[data-influencer-modal-name]');
  var mQuote = modal.querySelector('[data-influencer-modal-quote]');
  var mProdImg = modal.querySelector('[data-influencer-modal-prod-img]');
  var mProdName = modal.querySelector('[data-influencer-modal-prod-name]');
  var mProdPrice = modal.querySelector('[data-influencer-modal-prod-price]');
  var mFollowText = modal.querySelector('[data-influencer-modal-follow-text]');
  var mFollow = modal.querySelector('[data-influencer-modal-follow]');
  var mCta = modal.querySelector('[data-influencer-modal-cta]');
  var mProductLink = modal.querySelector('[data-influencer-modal-product-link]');
  var mClose = modal.querySelector('[data-influencer-close]');
  var mVideo = modal.querySelector('[data-influencer-modal-video]');
  var mMute = modal.querySelector('[data-influencer-modal-mute]');
  var iconMuted = mMute ? mMute.querySelector('[data-icon-muted]') : null;
  var iconSound = mMute ? mMute.querySelector('[data-icon-sound]') : null;

  function setSound(on) {
    if (iconMuted) iconMuted.classList.toggle('hidden', on);
    if (iconSound) iconSound.classList.toggle('hidden', !on);
  }
  if (mMute) {
    mMute.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!mVideo) return;
      mVideo.muted = !mVideo.muted;
      setSound(!mVideo.muted);
    });
  }

  // Focus-trap state
  var previouslyFocused = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function visibleFocusable() {
    return Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return !el.hidden && el.getClientRects().length > 0;
    });
  }

  function trapFocus() {
    previouslyFocused = document.activeElement;
    var focusable = visibleFocusable();
    if (focusable.length) focusable[0].focus();
  }

  function releaseFocus() {
    if (previouslyFocused && previouslyFocused.focus) {
      previouslyFocused.focus();
      previouslyFocused = null;
    }
  }

  // Hover pause moved to drift-rail.js, which owns the motion now. Leaving the
  // old animationPlayState writes here would do nothing: there is no animation.

  // Keep off-screen carousel videos out of the initial page load. The carousel
  // contains a duplicate set for its seamless loop, so eager autoplay otherwise
  // downloads every large video twice before the customer reaches this section.
  var cardVideos = section.querySelectorAll('[data-influencer-card-video]');

  function loadCardVideo(video) {
    if (!video || video.dataset.loaded === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    Array.prototype.forEach.call(sources, function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.loaded = 'true';
    video.load();
  }

  function playCardVideo(video) {
    loadCardVideo(video);
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          playCardVideo(video);
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '250px 150px', threshold: 0.01 });

    Array.prototype.forEach.call(cardVideos, function (video) {
      videoObserver.observe(video);
    });
  } else {
    Array.prototype.forEach.call(cardVideos, playCardVideo);
  }

  // Open modal — event delegation (works for cloned cards)
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-inf]');
    if (!card || !section.contains(card)) return;

    try {
      var d = JSON.parse(card.dataset.inf);
    } catch (err) {
      return;
    }

    // Media: play the video if this card has one, otherwise show the image
    if (d.video && mVideo) {
      if (mImg) mImg.classList.add('hidden');
      mVideo.src = d.video;
      mVideo.muted = true;
      mVideo.loop = true;
      mVideo.classList.remove('hidden');
      var playPromise = mVideo.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
      if (mMute) { mMute.classList.remove('hidden'); mMute.classList.add('flex'); }
      setSound(false);
    } else {
      if (mVideo) { mVideo.pause(); mVideo.removeAttribute('src'); mVideo.classList.add('hidden'); }
      if (mMute) { mMute.classList.add('hidden'); mMute.classList.remove('flex'); }
      if (mImg) { mImg.classList.remove('hidden'); mImg.src = d.img || ''; }
    }
    if (mHandle) mHandle.textContent = d.handle || '';
    if (mName) mName.textContent = d.name || '';
    if (mQuote) mQuote.textContent = d.quote || '';
    if (mProdImg) mProdImg.src = d.prodImg || '';
    if (mProdName) mProdName.textContent = d.product || '';
    if (mProdPrice) mProdPrice.textContent = d.price || '';

    // Set links
    var productUrl = d.productUrl || '#';
    if (mCta) mCta.href = productUrl;
    if (mProductLink) mProductLink.href = productUrl;
    /* Bottom row of the popup. It goes to THIS post when the block carries an
       Instagram post link, to the influencer's profile when it does not, and
       is hidden outright when there is neither, rather than sitting there as a
       dead href="#".

       style.display rather than a utility class: the row carries Tailwind's
       .flex, so .hidden against it is a source-order coin toss. */
    if (mFollow) {
      var profileUrl = d.profileUrl && d.profileUrl !== '#' ? d.profileUrl : '';
      var socialUrl = d.postUrl || profileUrl;
      if (socialUrl) {
        mFollow.href = socialUrl;
        mFollow.target = '_blank';
        mFollow.rel = 'noopener noreferrer';
        mFollow.style.display = '';
        if (mFollowText) {
          mFollowText.textContent = d.postUrl
            ? (mFollow.dataset.postLabel || 'View this post on Instagram')
            : 'Follow ' + (d.name || '');
        }
      } else {
        mFollow.style.display = 'none';
      }
    }

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    trapFocus();
  });

  // Close modal
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (mVideo) mVideo.pause();
    releaseFocus();
  }

  if (mClose) mClose.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeModal();
      return;
    }

    if (e.key === 'Tab') {
      var focusable = visibleFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });
})();
